import { Helmet } from 'react-helmet-async';
import { forwardRef, ReactNode } from 'react';
// @mui
import { Box, BoxProps } from '@mui/material';
import useTenantTheme from 'src/hooks/useTenantTheme';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  children: ReactNode;
  meta?: ReactNode;
  title: string;
}
const Page = forwardRef<HTMLDivElement, Props>(({ children, title = '', meta, ...other }, ref) => {
  const { pagePrefix } = useTenantTheme();
  const titleWithPrefix = pagePrefix ? `${pagePrefix}${title}` : title;

  return (
    <>
      <Helmet>
        <title>{titleWithPrefix}</title>
        {meta}
      </Helmet>

      <Box ref={ref} {...other}>
        {children}
      </Box>
    </>
  );
});

export default Page;
